import { TopMenuEvent } from './top-menu-events.model';

/**
 * Event detail link, built like EventMarketplaceComponent.getEventBasePath():
 * the network comes from the URL (the event's channel on /network-market/ pages), and the group is
 * matched by the event's group id first, since its group_slug can be stale against the network's groups.
 */
export function topMenuEventPath(url: string, event: TopMenuEvent, groups: any[]): string {
  const path = (url || '').split('?')[0];
  if (path.includes('/network-market/')) {
    const base = event.groupSlug ? `/${event.channelName}/${event.groupSlug}` : `/${event.channelName}`;
    return `${base}/event/${event.slug}`;
  }
  const network = path.split('/')[1];
  const group = (groups || []).find((g: any) => event.networkGroupId && g.id === event.networkGroupId)
    || (groups || []).find((g: any) => event.groupSlug && g.group_slug === event.groupSlug);
  const base = group ? `/${network}/${group.group_slug}` : `/${network}`;
  return `${base}/event/${event.slug}`;
}

/**
 * True on an event detail page (/<network>[/<group>]/event/<slug>). EventDetailsComponent reads the
 * slug once on init, so a router navigation to another event from there keeps the old event on screen.
 */
export function isEventDetailUrl(url: string): boolean {
  const segments = (url || '').split(/[?#]/)[0].split('/').filter(Boolean);
  const at = segments.indexOf('event');
  return at > 0 && at <= 2 && segments.length === at + 2 && segments[at + 1] !== 'preview';
}
